// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-bend-left';

export const Component = () => (
  <path d='M14.74 22.595H7.411c-.335 0-.527-.144-.527-.48 0-.335.192-.478.527-.478h7.327c1.868 0 3.496-.67 4.885-2.06 1.34-1.34 2.012-2.97 2.012-4.837 0-1.868-.67-3.496-2.012-4.838-1.389-1.34-3.017-2.011-4.885-2.011H3.676l4.07 4.07a.434.434 0 0 1 .145.336c0 .335-.192.479-.527.479a.434.434 0 0 1-.335-.144L2.144 7.747A.434.434 0 0 1 2 7.412a.54.54 0 0 1 .144-.383l4.885-4.885A.542.542 0 0 1 7.412 2c.335 0 .479.144.479.479 0 .191-.048.287-.144.335L3.676 6.885h11.063c2.156.048 4.023.814 5.556 2.3 1.532 1.532 2.299 3.4 2.299 5.555s-.767 4.022-2.3 5.555c-1.532 1.533-3.4 2.3-5.555 2.3Z' />
);

export const viewBox = '0 0 25 25';
